import { useEffect, useState } from "react";
import Menu from "./Menu";
import Premios from "./premios/List";
import Home from "./home/Home";
import Retos from "./retos/List";
import Pedidos from "./pedidos/List";
import Productos from "./productos/List";
import Marca from "./marca/Marca";
import Perfil from "./perfil/Profile";
import Ayuda from "./ayuda/ayuda";
import Terminos from "./terminos/Terminos";
import useTokenExpiration from "../../../../auth/TokenExpiration";
import { useNavigate } from "react-router-dom";
import { validateToken } from "../../../../auth/validateToken";
import ModalPreview from "./Modal";
import { VentaModalContext } from "./VentaModalContext";
import BottomNav from "./BottomNav";
import VentaComprobanteModal from "./home/VentaComprobanteModal";

function StatusContent({
  status,
  setView,
  setVentaModalOpen,
}: {
  status: string;
  setView: React.Dispatch<React.SetStateAction<string>>;
  setVentaModalOpen: (open: boolean) => void;
}) {
  switch (status) {
    case "Home":
      return <Home setView={setView} setVentaModalOpen={setVentaModalOpen} />;
    case "Premios":
      return <Premios setView={setView} />;
    case "Retos":
      return <Retos />;
    case "Pedidos":
      return <Pedidos />;
    case "Marca":
      return <Marca />;
    case "Perfil":
      return <Perfil setView={setView} />;
    case "Ayuda":
      return <Ayuda setView={setView} />;
    case "Terminos":
      return <Terminos />;
    case "Productos":
      return <Productos />;
    default:
      return <div>Unknown status.</div>;
  }
}

const UsuarioHome = () => {
  const [view, setView] = useState("Home");
  const [ventaModalOpen, setVentaModalOpen] = useState(false);
  const navigate = useNavigate();
  useTokenExpiration();

  useEffect(() => {
    if (sessionStorage.getItem("rol") === "Usuario") {
      const token = sessionStorage.getItem("token");
      if (token) {
        validateToken(token).then((isValid) => {
          if (!isValid) {
            sessionStorage.clear();
            navigate("/");
          }
        });
      } else {
        navigate("/");
      }
    } else {
      navigate("/");
    }
  }, [navigate]);

  return (
    <VentaModalContext.Provider
      value={() => {
        setVentaModalOpen(true);
      }}
    >
      <div className="flex h-screen w-screen flex-col overflow-hidden bg-[#f0f0f0]">
        <header className="shrink-0 bg-transparent md:hidden">
          <Menu view={view} setView={setView} />
        </header>
        <div className="flex min-h-0 flex-1 flex-col md:flex-row">
          <aside className="hidden h-full max-h-full min-h-0 w-full max-w-xs shrink-0 overflow-hidden border-r-0 bg-transparent md:flex md:max-w-[200px] md:flex-col lg:max-w-[220px]">
            <Menu view={view} setView={setView} />
          </aside>
          <main className="min-h-0 flex-1 overflow-y-auto px-0 pt-4 pb-24 md:px-0 md:pb-4 md:pt-4">
            <StatusContent
              status={view}
              setView={setView}
              setVentaModalOpen={setVentaModalOpen}
            />
          </main>
        </div>
        <BottomNav
          view={view}
          setView={setView}
          className="md:hidden"
          onNavInteraction={() => setVentaModalOpen(false)}
        />
        <VentaComprobanteModal
          view={ventaModalOpen}
          setView={setVentaModalOpen}
        />
        <ModalPreview />
      </div>
    </VentaModalContext.Provider>
  );
};

export default UsuarioHome;
